//消息接口
import Http from '../Core/Http';
export default class OnlineConsult extends Http {
  constructor(config) {
    super(config);
  }
  // 获取在线科室
  GetOnlineChatDepartmentOnDuty(data) {
    console.log(this)
    return this._post('/api/Interaction/GetOnlineChatDepartmentOnDuty',null,data);
  }
  //获取已咨询医生
  SearchDoctorOnlineChatMy(data){
    return this._post('/api/Interaction/SearchDoctorOnlineChatMy',null,data);
  }
  // 获取科室所有医生
  SearchDoctorOnlineChat(data){
    return this._post('/api/Interaction/SearchDoctorOnlineChat',null,data);
  }
  // 保存数据
  save(data){
    return this._post('/api/GuestMessage/Save',null,data);
  }
  // 获取回复消息
  getReplyMsg(data){
    let {pageIndex,pageSize}=data
    return this._get('/api/GuestMessage/GetAll', {
      pageIndex,
      pageSize
    });
  }
  // 获取科室回复消息
  GetAllDepartmentMessage(data){
    let {pageIndex,pageSize,departmentId}=data
    return this._get('/api/GuestMessage/GetAllDepartmentMessage', {
      pageIndex,
      pageSize,
      departmentId
    });
  }
  // 回复消息
  sendReplyMsg(data){
    return this._post('/api/GuestMessage/Replay',null,data);
  }
  // 获取健康宣教育
  GetDepartmentHealthTeaching(data){
    let {articleCategoryId,departmentId}=data
    return this._get('/api/HospitalProfile/GetDepartmentHealthTeaching', {
      articleCategoryId,
      departmentId,
    });
  }
}



// WEBPACK FOOTER //
// ./src/lib/PMA/OnlineConsultant.js